import React from "react";
import { format, getValueFromJson } from "../../../utils";
export function getCard(card, cardKey) {
  if (card && typeof card !== "object") {
    return card;
  } else if (card && cardKey) {
    return card[cardKey];
  }
  return null;
}
export function getWidthOfColumn(length, header) {
  let percentage = Number(header.basis?.replace("%", "") || NaN);
  return !Number.isNaN(percentage) ? percentage * length / 100 : 1;
}
export function buildColumns(header, Card, i18n, editMode) {
  return header?.reduce((acc, h) => {
    acc[h.label[0]] = {
      disableColumnMenu: false,
      filterable: false,
      width: h?.width,
      field: h.columnName || h.label[0],
      flex: getWidthOfColumn(header?.length, h),
      renderCell: params => {
        const {
          value
        } = params;
        return /*#__PURE__*/React.createElement(Card, {
          type: h.type || "",
          value: value
        });
      },
      headerName: i18n`${h.headerName || h.label[0]}`,
      align: h?.align || "left",
      headerAlign: h?.align || "left",
      cdmName: h?.columnName || "",
      editable: editMode || false,
      renderHeader: h?.renderHeader,
      sortable: h.sortable || false
    };
    return acc;
  }, {});
}
export function buildRows(listItems, header) {
  return listItems?.map((row, index) => {
    const {
      card,
      ...rest
    } = row;
    const dataGridRow = (card || []).reduce((acc, entry, i) => {
      if (!entry?.length) {
        return acc;
      }
      const headerName = header?.[i]?.columnName || header?.[i]?.label?.[0];
      acc[headerName] = entry[0].value;
      acc["id"] = row.id || index;
      acc["uniqueId"] = index;
      return acc;
    }, {});
    return {
      ...rest,
      ...dataGridRow
    };
  });
}
export function buildColumnTotalizers(columnsObj, totalizers, i18n) {
  totalizers?.total && delete totalizers?.total;
  const columnsValues = Object.values(columnsObj) || [];
  const totalizerObj = columnsValues.reduce((acc, columnConfs, index) => {
    const {
      cdmName,
      field,
      options
    } = columnConfs;
    const totalizerValue = totalizers[`Total_${cdmName.replace(".", "_")}`];
    if (totalizerValue) {
      acc.push({
        groupId: `totalizer_${index}`,
        headerName: format(totalizerValue, "normal", false, getValueFromJson(options, "fractionDigits"), getValueFromJson(options, "locale")),
        description: totalizerValue,
        children: [{
          field: field || ""
        }],
        headerAlign: "right"
      });
    }
    return acc;
  }, []);
  if (totalizerObj?.length) {
    totalizerObj.unshift({
      groupId: "Internal",
      headerName: i18n`Totals`,
      description: i18n`Totals`,
      children: [{
        field: columnsValues[0]?.field || ""
      }]
    });
  }
  return totalizerObj;
}